import React from 'react';
import { Handles, Rail, Slider, Tracks } from 'react-compound-slider';
import { Handle, SliderRail, sliderStyle, Track } from './RangeSliderComponents';

interface Props {
  range: [number, number],
  values: [number, number],
  onChange: (values: [number, number]) => void,
  children: ({value, labelHandle} : {value: number, labelHandle: string}) => React.ReactElement // children should be function of value to display
}

const DualRangeSlider: React.FunctionComponent<Props> = ({range, values, onChange, children}) => {
  const valueDisplay = children; // 
  return (
    <div className="dual-range-slider" style={{ width: '100%', height: '50px', position: 'relative' }}>
      <Slider
        mode={2}
        step={1}
        domain={range}
        rootStyle={sliderStyle}
        onChange={onChange}
        values={values}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={range}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
      <span className="value-label-min" style={{ position: 'absolute', left: 0, top: '20px' }}>
        { valueDisplay({value: values[0], labelHandle: 'min'}) }
      </span>
      <span className="value-label-max" style={{ position: 'absolute', right: 0, top: '20px' }}>
        {valueDisplay({ value: values[1], labelHandle: 'max' })}
      </span>
      
    </div>
  )
}

export default DualRangeSlider